var exports = {
  "X7": "UserProfileBadges.module__containerModal___MGM4LU",
  "j4": "UserProfileBadges.module__containerModalMobile___MGM4LU",
  "pP": "UserProfileBadges.module__containerModalDesktop___MGM4LU",
  "bZ": "UserProfileBadges.module__largeProfile___MGM4LU",
  "RS": "UserProfileBadges.module__containerPopout___MGM4LU",
  "Qk": "UserProfileBadges.module__badgeMobile___MGM4LU",
  "EJ": "UserProfileBadges.module__badgeDesktop___MGM4LU",
  "qS": "UserProfileBadges.module__badge___MGM4LU",
  "X8": "UserProfileBadges.module__sequenceBadge___MGM4LU",
  "Fi": "UserProfileBadges.module__sequenceBadgeMobile___MGM4LU",
  "Hd": "UserProfileBadges.module__sequenceBadgeDesktop___MGM4LU",
  "nf": "UserProfileBadges.module__link___MGM4LU",
  "uW": "UserProfileBadges.module__capsule___MGM4LU",
  "kn": "UserProfileBadges.module__capsuleButton___MGM4LU",
  "OS": "UserProfileBadges.module__more___MGM4LU",
};

module.exports = exports;
